/** True when runtime customPositions disagree with last committed ELK coords. */
export function customOverridesDriftFromHeld(custom, held, tasks, eps = 1.5) {
  if (!custom || !held || !tasks?.length) return false;
  for (const t of tasks) {
    const c = custom[t.id];
    if (!c || !Number.isFinite(c.x) || !Number.isFinite(c.y)) continue;
    const h = held[t.id];
    if (!h || !Number.isFinite(h.x) || !Number.isFinite(h.y)) return true;
    if (Math.abs(c.x - h.x) > eps || Math.abs(c.y - h.y) > eps) return true;
  }
  return false;
}

/** Skip layout choreography when Tidy/relayout produces the same coordinates ELK already showed. */
export function elkPositionsNearlyEqual(held, next, tasks, eps = 1) {
  if (!held || !next || !tasks?.length) return false;
  for (const t of tasks) {
    const a = held[t.id];
    const b = next[t.id];
    if (!a || !b) return false;
    if (!Number.isFinite(a.x) || !Number.isFinite(a.y)) return false;
    if (!Number.isFinite(b.x) || !Number.isFinite(b.y)) return false;
    if (Math.abs(a.x - b.x) > eps || Math.abs(a.y - b.y) > eps) return false;
  }
  return true;
}
